import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';

export function useDeleteExpense(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<void, string>({
    mutationFn: (id) => apiDelete<void>(operationsClient, expenseEndpoints.delete(id)),
    onSuccess: (_result, id) => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      toast.success('Draft expense discarded');
    },
  });
}
